<template>
<div style="height:100vh; overflow-y: scroll;">
<div class="outer">
<p><strong>&nbsp;</strong></p>
<h1 style="text-align: center;margin-bottom: 20px">《心理亦笙》用户注册协议</h1>
<p><strong>&nbsp;</strong></p>
<p>本协议由网络用户（以下称&ldquo;用户&rdquo;）与亦笙信息技术（深圳）有限公司开发《心理亦笙》平台（以下称&ldquo;心理亦笙&rdquo;）共同缔结，本协议具有合同效力。</p>
<p>一、协议内容</p>
<p>1、本协议内容包括协议正文及所有心理亦笙已经发布的或将来可能发布的各类规则。所有规则为本协议不可分割的组成部分，与协议正文具有同等法律效力。除另行明确声明外，心理亦笙提供的任何服务（以下称为&ldquo;心理亦笙平台服务&rdquo;）均受本协议约束。</p>
<p>2、用户应当在使用心理亦笙平台服务之前认真阅读全部协议内容，<strong>对于协议中以加粗字体显示的内容，您应重点阅读。</strong>如您对协议有任何疑问的，应向心理亦笙咨询。但无论您在使用心理亦笙平台服务之前是否事实上认真阅读了本协议的内容，只要您使用心理亦笙平台服务，则本协议即对您产生约束，届时您不应以未阅读本协议的内容或者未获得心理亦笙对您问询的解答等理由，主张本协议无效，或要求撤销本协议。</p>
<p>3、用户应当承诺接受并遵守本协议的约定。如果您不同意本协议的约定，应立即停止注册程序或停止使用心理亦笙平台服务。</p>
<p>4、心理亦笙有权根据需要不时地制订、修改本协议或各类规则，并以网站公示的方式进行公告，不再单独通知您。变更后的协议和规则一经在网站公布后，立即自动生效。如您不同意相关变更，应当立即停止使用心理亦笙平台服务。您继续使用心理亦笙平台服务的，即表示您接受经修订的协议和规则。</p>
<p>二、用户注册</p>
<p>1、资格</p>
<p>用户确认，在完成注册程序或以其他心理亦笙允许的方式实际使用心理亦笙平台服务时，您应当是年满18周岁具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且心理亦笙有权注销（或永久冻结）您的心理亦笙账户，如有损失，有权要求您及您的监护人赔偿。</p>
<p>2、账户</p>
<p>在用户签署本协议、完成会员注册程序或以其他心理亦笙允许的方式实际使用心理亦笙平台服务时，心理亦笙会向您提供唯一编号的心理亦笙账户（以下称&ldquo;账户&rdquo;）。</p>
<p>您可以对账户设置会员名和密码，通过该会员名密码或与该会员名密码关联的其它用户名密码登陆心理亦笙平台。您设置的会员名应当符合国家法律、法规及各类规范的要求，不得侵犯或涉嫌侵犯他人合法权益，不得违背社会公共利益或公共道德，心理亦笙有权拒绝前述会员名注册请求。</p>
<p>在登录心理亦笙注册过程中，您会被要求填写一些个人资料，并根据网站提示，正确、详尽及完整地提供个人资料，如需要更新时，也请确保资料的准确性、详实性和及时性，您应当对信息的完整性、真实性负责。如果您拒绝提供必要资料或拒绝提供完整资料，心理亦笙亦无法提供账户的注册服务。</p>
<p><strong>您必须妥善保管好自己的账户、会员名和密码</strong>，<strong>在您账户、会员名下的行为均视为您本人的行为。</strong>因会员本人泄露而造成的任何损失由会员本人负责。除非有法律规定或司法裁定，且征得心理亦笙的同意，否则，账户、会员名和密码不得以任何方式转让、赠与或继承（与账户相关的财产权益除外）。如果发现任何人不当使用您的账户或有任何其他可能危及您的账户安全的情形时，您应当立即以有效方式通知心理亦笙，要求心理亦笙暂停相关服务。您理解心理亦笙对您的请求采取行动需要合理时间，心理亦笙对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</p>
<p>为方便您使用心理亦笙平台服务及心理亦笙关联公司、其他组织或其他自然人的专业服务（以下称&ldquo;其他服务&rdquo;），您同意并授权心理亦笙将您在注册、使用心理亦笙平台服务过程中提供、形成的信息传递给向您提供其他服务的心理亦笙关联公司、其他组织或其他自然人，亦可从提供其他服务的心理亦笙关联公司、其他组织或其他自然人处获取您在注册、使用其他服务期间时提供、形成的信息。</p>
<p>3、会员</p>
<p>在您按照注册页面提示填写信息、阅读并同意本协议并完成全部注册程序后或以其他心理亦笙允许的方式实际使用心理亦笙平台服务时，您即成为心理亦笙平台会员（以下称&ldquo;会员&rdquo;）。</p>
<p>在注册时，您应当按照法律法规要求，或注册页面的提示准确提供，并及时更新您的资料，以使之真实、及时，完整和准确。如有合理理由怀疑您提供的资料错误、不实、过时或不完整的，心理亦笙有权向您发出询问、要求改正的通知，并有权直接做出删除相应资料的处理，直至中止、终止对您提供部分或全部心理亦笙平台服务。心理亦笙对此不承担任何责任，您将承担因此产生的任何直接或间接支出。</p>
<p>您应当准确填写并及时更新您提供的电子邮件地址、联系电话、联系地址、邮政编码等联系方式，以便心理亦笙或其他会员与您进行有效联系，因通过这些联系方式无法与您取得联系，导致您在使用心理亦笙平台服务过程中产生任何损失或增加费用的，应由您完全独自承担。</p>
<p>您在使用心理亦笙平台服务过程中，所产生的应纳税赋，以及一切硬件、软件、服务及其它方面的费用，均由您独自承担。</p>
<p>三、平台服务</p>
<p>1、通过心理亦笙及其关联公司提供的心理亦笙平台服务和其它服务，会员可在心理亦笙平台上获得针对本人的心理、健康咨询意见、指导及建议；可发布、上传个人信息、医疗检查（检验）信息、病历或处方信息、医疗需求信息、健康需求信息及其他心理亦笙许可的信息；对其他会员进行评价；参加心理亦笙组织的活动以及使用其它信息服务及技术服务等。上述服务包括可能的收费项目，您在预约相关服务之前可能需要支付相关费用。</p>
<p>2、您在心理亦笙平台上与其他会员发生纠纷时，一旦您或其它会员任一方或双方共同提交心理亦笙要求调处，则心理亦笙有权根据单方判断做出调处决定，您了解并同意接受心理亦笙的判断和调处决定，该决定将对您具有法律约束力。</p>

</div>
<div>
	<footerCommon></footerCommon>
</div>
</div>
</template>

<script>
export default {
    name: "agreementUser",
    components: {
        'footerCommon': () => import('../footerCommon'),
    },
    mounted() {
        this.$router.app.$children[0].$data.type = 'none';
    }
}
</script>

<style lang="scss" scoped>
.outer{
	padding: 40px;
	p.bold{font-weight: bold}
	p.right{text-align: right;}
	p{
		text-indent: 2rem;
		font-size: 14px;
		color: #434343;
		line-height: 2;
		a{
			text-decoration: underline;
		}
	}
}
</style>